import { Injectable } from '@angular/core';
import { ActiveState, EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { MatchingSession } from '@data/session/session.model';

export interface MatchingSessionState
  extends EntityState<MatchingSession, MatchingSession['id']>, ActiveState<MatchingSession['id']> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'sessions', resettable: true })
export class SessionStore extends EntityStore<MatchingSessionState> {
  constructor() {
    super();
  }
}
